<template>
  <div class="Legend" :class="{ 'Legend--visible' : visible, 'Legend--mobile': mobile }">
    <h3>Legenda</h3>
    <svg  
      aria-hidden="true" 
      focusable="false" 
      data-prefix="fal" 
      data-icon="times" 
      class="svg-inline--fa fa-times fa-w-10" 
      role="img" 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 320 512"
      @click="handleClose">
      <path fill="currentColor" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19 0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34 120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12 3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12 3.12-8.19 0-11.31L193.94 256z"></path>
    </svg>
    <ul>
      <li v-for="(item, index) in items" :key="index" :style="liStyle({ item })">
        <span :style="style({ item })"></span> 
        <span>{{ item.label }}</span> 
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Legend',
  props: {
    items: {
      type: Array,
      default: function() {
        return [{
          color: "rgba(178,213,126,0.8)",
          label: "Verkenningswijk"
        }, {
          color: "rgba(249,199,117,0.8)",
          label: "Middellange termijn wijk"
        }, {
          color: "rgba(243,125,125,0.8)",
          label: "Lange termijn wijk"
        }, {
          color: "rgba(214,168,210,0.8)",
          label: "Natuurlijk temp (individuele oplossing)"
        }, {
          color: "rgba(214,215,211, 0.8)",
          label: "Bedrijventerrijn"
        }]
      }
    },
    visible: {
      type: Boolean,
      default: true
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  
  methods: {
    handleClose() {
      this.$emit('close')
    },
    /**
     * Styling of the image / color element
     */
    style({ item }) {
      if (item.pattern) {
        return {
          backgroundImage: `url(${item.pattern})`
        }
      }
      else if (item.image) {
        return {
          backgroundImage: `url(${item.image})`,
          backgroundRepeat: 'no-repeat',
          width: '32px',
          height: '32px'
        }
      }
      else if (item.color) {
        return { 
          'backgroundColor': item.color 
        }
      }

      return {
        backgroundColor: 'transparent'
      }
    },
    /**
     * Styling of the list item
     */
    liStyle({ item }) {
      if (item.image) {
        return {
          alignItems: 'center'
        }
      }
      return {}
    }
  }
}
</script>

<style lang="scss">
.Legend {
  position: absolute;
  top: 0;
  left: 0;
  width: 260px;
  background: white;
  margin-left: -260px;
  transition: margin 0.4s ease-in-out, width 0.4s ease-in-out;;
  z-index: 9999;
  opacity: 0.99;
  padding: 16px;
  
  &--mobile {
    width: 100%;
    margin-left: -100%;
  }

  &--visible {
    margin-left: 0;
    box-shadow: -1px -1px 0px 0px rgba(223,226,229,1) inset;
  }

  h3 {
    margin-top: 6px;
  }

  svg {
    position: absolute;
    right: 12px;
    top: 22px;
    height: 24px;
    width: 24px;
    cursor: pointer;
  }

  ul {
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      margin-bottom: 6px;
      display: flex;

      span:first-child {
        display: inline-block;
        width: 20px;
        height: 1em;
        margin-top: 2px;
        margin-right: 6px;
        min-width: 20px;
      }
    }
  }
}
</style>